import React, { useState } from 'react'
import MyButton from '../../../../../../UI/form/MyButton'
import MyModal from '../../../../../../UI/modal/MyModal'
import AddCardIcon from '@mui/icons-material/AddCard';
import SupplyBillForm from './form/SupplyBillForm';

const AddSupplyOrderBillButton = ({ checked, supplyOrderId, setChecked }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            <AddCardIcon />
            <span>Рахунок</span>
        </MyButton>

        <MyModal
            classNameAdd='supplyOrderModal'
            open={open}
            setOpen={setOpen}
            header={'Створення рахунку'}
            disableClickOutside={true}
            content={
                <SupplyBillForm
                    // supplyOrderBd={supplyOrder}
                    supplyOrderId={supplyOrderId}
                    // supplyOrderItems={supplyOrderItems}
                    checked={checked}
                    setChecked={setChecked}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AddSupplyOrderBillButton